var vskoLogo = angular.module('vskoLogo', []);

vskoLogo.directive('vskoLogo', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-logo.html'),
    replace: false,
    scope: {},
    link: function($scope, element, attrs) {
      'use strict';
    }
  }
}]);
